/* Sticksy theme JS — timers, instant quote, configurator, reveals, stat counters */
(function () {
  'use strict';

  /* ========== Money formatting (uses shop money format when available) ========== */
  function formatMoneyCents(cents, moneyFormat) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    if (moneyFormat) {
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount);
    }
    return '$' + amount;
  }

  /* ========== Same-day cutoff countdown ========== */
  function initTimers() {
    var heroH = document.querySelector('[data-timer-h]');
    var chip = document.querySelector('[data-chip-timer]');
    var cta = document.querySelector('[data-cta-timer]');
    if (!heroH && !chip && !cta) return;

    var host = document.querySelector('[data-cutoff-hour]');
    var cutoffHour = host ? parseInt(host.getAttribute('data-cutoff-hour'), 10) : 24;
    if (!cutoffHour || isNaN(cutoffHour)) cutoffHour = 24;

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var now = new Date();
      var target = new Date(now);
      target.setHours(cutoffHour, 0, 0, 0);
      if (target <= now) target.setDate(target.getDate() + 1);
      var d = target - now;
      var h = Math.floor(d / 3.6e6);
      var m = Math.floor((d % 3.6e6) / 6e4);
      var s = Math.floor((d % 6e4) / 1e3);
      if (heroH) {
        heroH.textContent = pad(h);
        var em = document.querySelector('[data-timer-m]');
        var es = document.querySelector('[data-timer-s]');
        if (em) em.textContent = pad(m);
        if (es) es.textContent = pad(s);
      }
      var str = pad(h) + ':' + pad(m) + ':' + pad(s);
      if (chip) chip.textContent = str;
      if (cta) cta.textContent = str;
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ========== Instant quote (homepage) ========== */
  function initQuote() {
    var card = document.querySelector('[data-quote-tool]');
    if (!card) return;
    var product = card.querySelector('[data-q-product]');
    var qty = card.querySelector('[data-q-qty]');
    var size = card.querySelector('[data-q-size]');
    var unitLab = card.querySelector('[data-q-unit-lab]');
    var total = card.querySelector('[data-q-total]');
    var each = card.querySelector('[data-q-each]');
    var cta = card.querySelector('[data-q-cta]');

    function discountFor(q) {
      if (q >= 5000) return 0.40;
      if (q >= 1000) return 0.30;
      if (q >= 500) return 0.22;
      if (q >= 250) return 0.15;
      if (q >= 100) return 0.08;
      return 0;
    }

    function calc() {
      var opt = product.selectedOptions[0];
      if (!opt) return;
      var base = parseFloat(opt.dataset.base) || 0;
      var unit = opt.dataset.unit;
      var q = Math.max(1, parseInt(qty.value, 10) || 1);
      var s = Math.max(1, parseFloat(size.value) || 1);
      unitLab.textContent = unit === 'sqft' ? '(sq ft each)' : '(each)';
      var disc = discountFor(q);
      var per = base * (unit === 'sqft' ? s : 1) * (1 - disc);
      var t = per * q;
      total.textContent = '$' + t.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      each.innerHTML = '$' + per.toFixed(per < 1 ? 3 : 2) + ' / unit' +
        '<span class="disc">' + (disc ? '−' + Math.round(disc * 100) + '% volume discount' : '') + '</span>';
      if (cta && opt.dataset.url) cta.setAttribute('href', opt.dataset.url);
    }
    [product, qty, size].forEach(function (el) { el.addEventListener('input', calc); });
    calc();
  }

  /* ========== Product configurator ========== */
  function initConfigurator() {
    var root = document.querySelector('[data-configurator]');
    if (!root) return;

    var cfgEl = root.querySelector('[data-shop-config]');
    var cfg = { moneyFormat: '${{amount}}', freeShipThreshold: 9900 };
    if (cfgEl) { try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {} }

    var mode = root.getAttribute('data-mode') || 'tiers';
    var unitPriceCents = parseInt(root.getAttribute('data-unit-price'), 10) || 0; // $ per area unit, in cents (sqft mode)
    var minSqft = parseInt(root.getAttribute('data-min-sqft'), 10) || 1;
    // area unit: 'sqft' (÷144 sq in) or 'sqin' (raw square inches)
    var areaUnit = root.getAttribute('data-area-unit') === 'sqin' ? 'sqin' : 'sqft';
    var areaDiv = areaUnit === 'sqin' ? 1 : 144;
    var areaName = areaUnit === 'sqin' ? 'sq in' : 'sq ft';
    // sizes mode: optional area-priced Custom tile (rate variant supplied by section)
    var customRateCents = parseInt(root.getAttribute('data-custom-rate'), 10) || 0;
    var customRateVariant = root.getAttribute('data-custom-rate-variant') || '';
    var customUnit = root.getAttribute('data-custom-unit') === 'sqin' ? 'sqin' : 'sqft';
    var customDiv = customUnit === 'sqin' ? 1 : 144;
    var customName = customUnit === 'sqin' ? 'sq in' : 'sq ft';
    var customAreaActive = function () { return state.customSize && customRateCents > 0 && customRateVariant; };
    function customUnitsFor(qty) {
      return Math.max(1, Math.ceil((state.w * state.h / customDiv) * qty));
    }

    var sticker = root.querySelector('[data-sticker]');
    var stageDims = root.querySelector('[data-stage-dims]');
    var variantInput = root.querySelector('[data-variant-id]');
    var cartQtyInput = root.querySelector('[data-cart-qty]');
    var wInit = parseFloat((root.querySelector('[data-size-w]') || {}).value) || 3;
    var hInit = parseFloat((root.querySelector('[data-size-h]') || {}).value) || 3;
    var state = { shape: 'die', mat: 'white', lam: 'gloss', w: wInit, h: hInit, pieces: 1, qtyLabel: '', priceCents: 0, sizeLabel: '', customSize: false };
    // No shape picker on this product (banners, sqft mode…) → preview as a
    // flat rectangle, not a die-cut sticker blob.
    if (!root.querySelector('.opt[data-group="shape"]')) state.shape = 'flat';

    // ===== SIZES MODE: Size presets × Quantity tiers (variants = the price matrix) =====
    var sizeVariants = [];
    var vdEl = root.querySelector('[data-variant-data]');
    if (vdEl) { try { sizeVariants = JSON.parse(vdEl.textContent); } catch (e) {} }

    function parseDims(label) {
      var m = String(label).match(/(\d+(?:\.\d+)?)\s*["\u2033\u201d']?\s*[x\u00d7]\s*(\d+(?:\.\d+)?)/i);
      return m ? { w: parseFloat(m[1]), h: parseFloat(m[2]) } : null;
    }
    function currentSizeVariant() {
      for (var i = 0; i < sizeVariants.length; i++) {
        if (sizeVariants[i].size === state.sizeLabel && sizeVariants[i].qty === state.qtyLabel) return sizeVariants[i];
      }
      return null;
    }
    function signQty() {
      var n = parseInt(String(state.qtyLabel).replace(/[^\d]/g, ''), 10);
      return n > 0 ? n : 1;
    }
    function addonState() {
      var list = [], total = 0;
      root.querySelectorAll('[data-addon]:checked').forEach(function (cb) {
        var perUnit = cb.getAttribute('data-per-unit') === '1';
        var price = parseInt(cb.getAttribute('data-addon-price'), 10) || 0;
        var cost = perUnit ? price * signQty() : price;
        total += cost;
        list.push({ title: cb.getAttribute('data-addon-title'), cost: cost });
      });
      return { list: list, total: total };
    }

    function labelFor(group) {
      var b = root.querySelector('.opt.active[data-group="' + group + '"]');
      return b ? b.dataset.label : '';
    }

    function render() {
      // preview classes
      if (sticker) {
        sticker.className = 'sticker shape-' + state.shape +
          (state.mat !== 'white' ? ' mat-' + state.mat : '') +
          (state.lam === 'gloss' ? ' lam-gloss' : '');
        var maxDim = Math.max(state.w, state.h);
        var scale = Math.min(0.82, 0.38 + maxDim * 0.055);
        // fit inside the square stage for any aspect ratio (wide OR tall)
        var aspect = (state.w || 1) / (state.h || 1);
        var widthPct = state.shape === 'oval' ? scale : (aspect >= 1 ? scale : scale * aspect);
        sticker.style.width = (widthPct * 100) + '%';
        sticker.style.aspectRatio = state.shape === 'oval' ? '4/3' : (state.w || 1) + '/' + (state.h || 1);
      }
      if (stageDims) stageDims.textContent = state.w + '″ × ' + state.h + '″';

      // selection labels
      ['shape', 'mat', 'lam'].forEach(function (g) {
        var sel = root.querySelector('[data-sel="' + g + '"]');
        if (sel) sel.textContent = labelFor(g);
      });
      var sizeSel = root.querySelector('[data-sel="size"]');
      if (sizeSel) sizeSel.textContent = state.w + '″ × ' + state.h + '″';
      var qtySel = root.querySelector('[data-sel="qty"]');
      if (qtySel) qtySel.textContent = state.qtyLabel;

      // ===== SQFT/SQIN MODE: compute billed area → cart quantity =====
      var billedUnits = 1;
      if (mode === 'sqft') {
        var areaPerPiece = (state.w * state.h) / areaDiv;
        var rawArea = areaPerPiece * state.pieces;
        billedUnits = Math.max(minSqft, Math.ceil(rawArea));
        state.priceCents = billedUnits * unitPriceCents;
        state.qtyLabel = state.pieces + (state.pieces === 1 ? ' piece' : ' pieces');
        if (cartQtyInput) cartQtyInput.value = billedUnits;

        var readout = root.querySelector('[data-sqft-readout]');
        if (readout) {
          readout.textContent = areaPerPiece.toFixed(2) + ' ' + areaName + ' each × ' + state.pieces +
            ' = ' + rawArea.toFixed(2) + ' ' + areaName + ' → billed as ' + billedUnits + ' ' + areaName;
        }
        var piecesSel = root.querySelector('[data-sel="pieces"]');
        if (piecesSel) piecesSel.textContent = state.pieces;
        var sumBilled = root.querySelector('[data-sum-billed]');
        if (sumBilled) sumBilled.textContent = billedUnits + ' ' + areaName + ' @ ' + formatMoneyCents(unitPriceCents, cfg.moneyFormat) + '/' + areaName;
      } else if (mode === 'sizes') {
        state.pieces = signQty();
        if (customAreaActive()) {
          // Custom size billed by area: rate variant × billed units = exact checkout
          billedUnits = customUnitsFor(state.pieces);
          state.priceCents = billedUnits * customRateCents;
          if (variantInput) variantInput.value = customRateVariant;
          if (cartQtyInput) cartQtyInput.value = billedUnits;
        } else {
          var sv = currentSizeVariant();
          if (sv) {
            state.priceCents = sv.price;
            if (variantInput) variantInput.value = sv.id;
          }
          if (cartQtyInput) cartQtyInput.value = 1; // the variant IS the size+qty tier
        }
        // reprice quantity tiles: variant matrix, or computed area price on Custom
        root.querySelectorAll('[data-qty-choice]').forEach(function (b) {
          var q = b.getAttribute('data-qty-choice');
          var per = b.querySelector('[data-per]');
          if (customAreaActive()) {
            var qn = parseInt(String(q).replace(/[^\d]/g, ''), 10) || 1;
            b.disabled = false;
            if (per) per.textContent = formatMoneyCents(customUnitsFor(qn) * customRateCents, cfg.moneyFormat);
            return;
          }
          var vv = null;
          for (var i = 0; i < sizeVariants.length; i++) {
            if (sizeVariants[i].size === state.sizeLabel && sizeVariants[i].qty === q) { vv = sizeVariants[i]; break; }
          }
          if (vv) { b.disabled = !vv.available; if (per) per.textContent = formatMoneyCents(vv.price, cfg.moneyFormat); }
          else { b.disabled = true; if (per) per.textContent = '\u2014'; }
        });
        var sumBilled2 = root.querySelector('[data-sum-billed]');
        var billedRow = root.querySelector('[data-sum-billed-row]');
        if (billedRow) billedRow.hidden = !customAreaActive();
        if (sumBilled2 && customAreaActive()) {
          sumBilled2.textContent = billedUnits + ' ' + customName + ' @ ' + formatMoneyCents(customRateCents, cfg.moneyFormat) + '/' + customName;
        }
      } else if (cartQtyInput) {
        cartQtyInput.value = 1; // tiers mode: the variant IS the quantity tier
      }

      // ===== ADD-ONS (any mode) =====
      var ad = addonState();
      var adSel = root.querySelector('[data-sel="addons"]');
      if (adSel) adSel.textContent = ad.list.length ? ad.list.map(function (a) { return a.title; }).join(' + ') : 'None';
      var adRow = root.querySelector('[data-sum-addons-row]');
      if (adRow) {
        adRow.hidden = !ad.list.length;
        var adVal = root.querySelector('[data-sum-addons]');
        if (adVal) adVal.textContent = ad.list.map(function (a) { return a.title + ' ' + formatMoneyCents(a.cost, cfg.moneyFormat); }).join(' \u00b7 ');
      }
      var displayTotal = (state.priceCents || 0) + ad.total;

      // hidden line item properties
      var props = {
        shape: labelFor('shape'), mat: labelFor('mat'), lam: labelFor('lam'),
        size: (mode === 'sizes' && !state.customSize && state.sizeLabel) ? state.sizeLabel : state.w + 'in x ' + state.h + 'in',
        pieces: String(state.pieces),
        billing: mode === 'sqft'
          ? billedUnits + ' ' + areaName + ' @ ' + formatMoneyCents(unitPriceCents, cfg.moneyFormat) + '/' + areaName
          : (mode === 'sizes' && customAreaActive())
            ? billedUnits + ' ' + customName + ' @ ' + formatMoneyCents(customRateCents, cfg.moneyFormat) + '/' + customName
            : ''
      };
      Object.keys(props).forEach(function (k) {
        var input = root.querySelector('[data-prop="' + k + '"]');
        if (input) input.value = props[k];
      });

      // summary
      var sumConfig = root.querySelector('[data-sum-config]');
      if (sumConfig) {
        var bits = [labelFor('shape'), labelFor('mat'), labelFor('lam')]
          .filter(Boolean)
          .map(function (s) { return s.split(' ')[0]; });
        sumConfig.textContent = bits.length ? bits.join(' · ') : 'Custom print';
      }
      var sumSizeQty = root.querySelector('[data-sum-sizeqty]');
      if (sumSizeQty) sumSizeQty.textContent = state.w + '″×' + state.h + '″ · ' + state.qtyLabel;
      var sumShip = root.querySelector('[data-sum-ship]');
      if (sumShip) {
        var free = displayTotal >= cfg.freeShipThreshold;
        sumShip.textContent = free ? 'FREE ground shipping' : 'Ground calculated at checkout (free over ' + formatMoneyCents(cfg.freeShipThreshold, cfg.moneyFormat) + ')';
        sumShip.classList.toggle('free', free);
      }

      // price
      var totalEl = root.querySelector('[data-total]');
      if (totalEl && displayTotal) totalEl.textContent = formatMoneyCents(displayTotal, cfg.moneyFormat);
      var perLine = root.querySelector('[data-per-line]');
      if (perLine) {
        if (mode === 'sqft') {
          if (state.pieces > 0 && state.priceCents) {
            var perPiece = state.priceCents / state.pieces;
            perLine.innerHTML = formatMoneyCents(perPiece, cfg.moneyFormat) + ' per piece';
          }
        } else {
          var qtyNum = parseInt(String(state.qtyLabel).replace(/[^\d]/g, ''), 10);
          if (qtyNum > 0 && displayTotal) {
            var perCents = displayTotal / qtyNum;
            perLine.innerHTML = (perCents < 100 ? '$' + (perCents / 100).toFixed(3) : formatMoneyCents(perCents, cfg.moneyFormat)) + ' each';
          }
        }
      }
    }

    // option buttons (shape/material/finish)
    root.querySelectorAll('.opt[data-group]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var g = btn.dataset.group;
        root.querySelectorAll('.opt[data-group="' + g + '"]').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        state[g] = btn.dataset.value;
        render();
      });
    });

    // quantity buttons = real variants
    var qtyBtns = root.querySelectorAll('.qty-opt[data-variant]');
    qtyBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        qtyBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        state.qtyLabel = btn.dataset.qtyLabel;
        state.priceCents = parseInt(btn.dataset.price, 10) || 0;
        if (variantInput) variantInput.value = btn.dataset.variant;
        render();
      });
    });
    // initialize from active variant (tiers mode only)
    if (mode !== 'sqft') {
      var active = root.querySelector('.qty-opt.active[data-variant]') || qtyBtns[0];
      if (active) {
        state.qtyLabel = active.dataset.qtyLabel;
        state.priceCents = parseInt(active.dataset.price, 10) || 0;
        if (variantInput) variantInput.value = active.dataset.variant;
      }
    }

    // sizes mode: build qty tiles from Option2 values, wire size buttons
    if (mode === 'sizes' && sizeVariants.length) {
      var qtys = [];
      sizeVariants.forEach(function (v) { if (qtys.indexOf(v.qty) === -1) qtys.push(v.qty); });
      var sGrid = root.querySelector('[data-qty-grid]');
      if (sGrid) {
        qtys.forEach(function (q, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'qty-opt' + (i === 0 ? ' active' : '');
          b.setAttribute('data-qty-choice', q);
          b.innerHTML = '<div class="q">' + q + '</div><div class="per" data-per></div>';
          b.addEventListener('click', function () {
            if (b.disabled) return;
            sGrid.querySelectorAll('.qty-opt').forEach(function (x) { x.classList.remove('active'); });
            b.classList.add('active');
            state.qtyLabel = q;
            render();
          });
          sGrid.appendChild(b);
        });
        state.qtyLabel = qtys[0];
      }
      var sizeBtns = root.querySelectorAll('[data-size-choice]');
      if (sizeBtns.length) {
        state.sizeLabel = sizeBtns[0].getAttribute('data-size-choice');
        state.customSize = sizeBtns[0].hasAttribute('data-custom');
        var d0 = parseDims(state.sizeLabel);
        if (d0) { state.w = d0.w; state.h = d0.h; }
        sizeBtns.forEach(function (b) {
          b.addEventListener('click', function () {
            sizeBtns.forEach(function (x) { x.classList.remove('active'); });
            b.classList.add('active');
            state.sizeLabel = b.getAttribute('data-size-choice');
            state.customSize = b.hasAttribute('data-custom');
            var c = root.querySelector('[data-custom-size]');
            if (c) c.hidden = !state.customSize;
            if (!state.customSize) {
              var d = parseDims(state.sizeLabel);
              if (d) { state.w = d.w; state.h = d.h; }
            }
            render();
          });
        });
      }
    }

    // add-on checkboxes reprice live (any mode)
    root.querySelectorAll('[data-addon]').forEach(function (cb) {
      cb.addEventListener('change', function () { render(); });
    });

    // pieces input (sqft mode)
    var piecesIn = root.querySelector('[data-pieces]');
    if (piecesIn) {
      piecesIn.addEventListener('input', function () {
        state.pieces = Math.max(1, parseInt(piecesIn.value, 10) || 1);
        render();
      });
    }

    // size inputs — clamp to each product's real min/max (set in section settings),
    // not a hardcoded sticker default. A 120″ banner must bill as 120″.
    var wIn = root.querySelector('[data-size-w]');
    var hIn = root.querySelector('[data-size-h]');
    function clampTo(el, v) {
      var min = parseFloat(el.min) || 1;
      var max = parseFloat(el.max) || 10000;
      return Math.min(max, Math.max(min, v));
    }
    if (wIn) wIn.addEventListener('input', function () { state.w = clampTo(wIn, parseFloat(wIn.value) || 1); render(); });
    if (hIn) hIn.addEventListener('input', function () { state.h = clampTo(hIn, parseFloat(hIn.value) || 1); render(); });

    // thumbs
    root.querySelectorAll('.thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
      });
    });

    // ===== Artwork upload (native Shopify file line-item property) =====
    (function initArtwork() {
      var wrap = root.querySelector('[data-artwork]');
      if (!wrap) return;
      var fileIn = wrap.querySelector('[data-art-file]');
      var laterCheck = wrap.querySelector('[data-art-later]');
      var chip = wrap.querySelector('[data-file-chip]');
      var chipName = wrap.querySelector('[data-file-name]');
      var chipSize = wrap.querySelector('[data-file-size]');
      var removeBtn = wrap.querySelector('[data-file-remove]');
      var errorEl = wrap.querySelector('[data-file-error]');
      var statusSel = wrap.querySelector('[data-art-status]');
      var statusProp = wrap.querySelector('[data-art-status-prop]');
      var dropzone = wrap.querySelector('[data-dropzone]');
      var form = wrap.closest('form');
      var face = root.querySelector('.sticker-face');
      var art = root.querySelector('.sticker-face .art');
      var MAX_BYTES = 20 * 1024 * 1024; // Shopify's ~20MB cap for property uploads
      var nativeUpload = !!fileIn; // false when an upload app block replaces the built-in field

      function showError(msg) {
        if (!errorEl) return;
        errorEl.textContent = msg || '';
        errorEl.hidden = !msg;
      }
      function humanSize(bytes) {
        if (bytes > 1048576) return (bytes / 1048576).toFixed(1) + ' MB';
        return Math.max(1, Math.round(bytes / 1024)) + ' KB';
      }
      function extOf(name) { return (name.split('.').pop() || '').toLowerCase(); }
      function allowedExts() {
        var accept = (fileIn && fileIn.getAttribute('accept')) || '';
        return accept.split(',').map(function (s) { return s.trim().replace('.', '').toLowerCase(); }).filter(Boolean);
      }
      function setState(status, propText) {
        if (statusSel) statusSel.textContent = status;
        if (statusProp) statusProp.value = propText;
      }
      function clearPreview() {
        if (face) face.style.backgroundImage = '';
        if (art) art.style.display = '';
      }
      function clearFile() {
        if (!nativeUpload) return;
        fileIn.value = '';
        if (chip) chip.hidden = true;
        clearPreview();
        var later = laterCheck && laterCheck.checked;
        setState(later ? 'Sending later' : 'None yet',
                 later ? 'Customer will send file after checkout' : 'No file uploaded yet');
      }

      if (nativeUpload) fileIn.addEventListener('change', function () {
        showError('');
        var f = fileIn.files && fileIn.files[0];
        if (!f) { clearFile(); return; }
        var exts = allowedExts();
        if (exts.length && exts.indexOf(extOf(f.name)) === -1) {
          showError('That file type isn\u2019t supported. Accepted: ' + exts.join(', ').toUpperCase());
          clearFile();
          return;
        }
        if (f.size > MAX_BYTES) {
          showError('File is ' + humanSize(f.size) + ' \u2014 the checkout upload limit is 20 MB. Tick \u201csend after checkout\u201d below and we\u2019ll email you a link for the big file.');
          clearFile();
          return;
        }
        if (laterCheck) laterCheck.checked = false;
        if (chipName) chipName.textContent = f.name;
        if (chipSize) chipSize.textContent = humanSize(f.size);
        if (chip) chip.hidden = false;
        setState('Attached \u2713', 'Uploaded at checkout: ' + f.name);
        if (/^image\/(png|jpe?g|svg\+xml|webp)$/.test(f.type) && face) {
          var reader = new FileReader();
          reader.onload = function (e) {
            face.style.backgroundImage = 'url(' + e.target.result + ')';
            face.style.backgroundSize = 'cover';
            face.style.backgroundPosition = 'center';
            if (art) art.style.display = 'none';
          };
          reader.readAsDataURL(f);
        } else {
          clearPreview();
        }
      });

      if (removeBtn) removeBtn.addEventListener('click', function () { showError(''); clearFile(); });

      // ===== AI-generated artwork disclosure =====
      var aiCheck = wrap.querySelector('[data-ai-check]');
      var aiWarn = wrap.querySelector('[data-ai-warn]');
      var aiProp = wrap.querySelector('[data-ai-prop]');
      if (aiCheck) {
        aiCheck.addEventListener('change', function () {
          if (aiWarn) aiWarn.hidden = !aiCheck.checked;
          if (aiProp) aiProp.value = aiCheck.checked ? 'Yes — customer notified that AI images may pixelate at print size' : '';
        });
      }

      // ===== Design service ($ product added alongside the order) =====
      var dsCheck = wrap.querySelector('[data-ds-check]');
      var productTitle = root.getAttribute('data-product-title') || 'print order';
      if (dsCheck) {
        dsCheck.addEventListener('change', function () {
          showError('');
          if (dsCheck.checked) {
            setState('Designer will create it', 'Design service purchased — our team creates the artwork');
            if (laterCheck) laterCheck.checked = false;
          } else if (!(fileIn.files && fileIn.files.length)) {
            setState('None yet', 'No file uploaded yet');
          }
        });
      }

      if (laterCheck) laterCheck.addEventListener('change', function () {
        showError('');
        if (laterCheck.checked) {
          fileIn.value = '';
          if (chip) chip.hidden = true;
          clearPreview();
          setState('Sending later', 'Customer will send file after checkout');
        } else {
          setState('None yet', 'No file uploaded yet');
        }
      });

      if (dropzone) {
        ['dragenter', 'dragover'].forEach(function (ev) {
          dropzone.addEventListener(ev, function (e) { e.preventDefault(); dropzone.classList.add('dragging'); });
        });
        ['dragleave', 'drop'].forEach(function (ev) {
          dropzone.addEventListener(ev, function (e) { e.preventDefault(); dropzone.classList.remove('dragging'); });
        });
        dropzone.addEventListener('drop', function (e) {
          if (e.dataTransfer && e.dataTransfer.files.length) {
            fileIn.files = e.dataTransfer.files;
            fileIn.dispatchEvent(new Event('change'));
          }
        });
      }

      // require a choice before add-to-cart; add design service to cart first if selected
      // require a choice before add-to-cart; validate add-on minimums; queue
      // add-ons + design service as AJAX cart adds before the main form posts
      if (form) {
        form.addEventListener('submit', function (e) {
          var hasFile = nativeUpload && fileIn.files && fileIn.files.length > 0;
          var later = laterCheck && laterCheck.checked;
          var ds = dsCheck && dsCheck.checked;
          var addonChecks = Array.prototype.slice.call(root.querySelectorAll('[data-addon]:checked'));

          // artwork gate (only when our built-in field is live)
          if (nativeUpload && !hasFile && !later && !ds) {
            e.preventDefault();
            showError('Attach your artwork, tick \u201csend after checkout\u201d, or add the design service \u2014 then add to cart.');
            wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }

          // add-on minimum-quantity gate (e.g. contour cut: min 10 signs)
          var qtySel = root.querySelector('[data-sel="qty"]');
          var orderQty = parseInt(String(qtySel ? qtySel.textContent : '').replace(/[^\d]/g, ''), 10) || 1;
          for (var i = 0; i < addonChecks.length; i++) {
            var minQ = parseInt(addonChecks[i].getAttribute('data-min-qty'), 10) || 1;
            if (orderQty < minQ) {
              e.preventDefault();
              showError(addonChecks[i].getAttribute('data-addon-title') + ' requires a minimum of ' + minQ + ' signs \u2014 raise the quantity or untick it.');
              wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
              return;
            }
          }

          // build the queue of extra cart adds
          var pending = [];
          addonChecks.forEach(function (cb) {
            var perUnit = cb.getAttribute('data-per-unit') === '1';
            pending.push({
              id: parseInt(cb.getAttribute('data-addon-variant'), 10),
              quantity: perUnit ? orderQty : 1,
              properties: { 'For': productTitle, 'Add-on': cb.getAttribute('data-addon-title') }
            });
          });
          if (ds) {
            pending.push({
              id: parseInt(dsCheck.getAttribute('data-ds-variant'), 10),
              quantity: 1,
              properties: { 'For': productTitle }
            });
          }
          if (!pending.length) return; // plain order: let the form post normally

          e.preventDefault();
          var btn = form.querySelector('[type="submit"]');
          if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }
          var chain = Promise.resolve();
          var failed = false;
          pending.forEach(function (item) {
            chain = chain.then(function () {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(item)
              }).then(function (r) { if (!r.ok) failed = true; });
            });
          });
          chain.then(function () {
            if (failed) {
              if (btn) { btn.disabled = false; btn.textContent = 'Add to cart \u2192'; }
              showError('Couldn\u2019t add an add-on \u2014 check that its product is active in Shopify, then try again.');
            } else {
              form.submit(); // native submit: does not re-trigger this handler
            }
          }).catch(function () {
            if (btn) { btn.disabled = false; btn.textContent = 'Add to cart \u2192'; }
            showError('Something went wrong adding extras \u2014 please try again.');
          });
        });
      }
    })();

    render();
  }

  /* ========== Reveal on scroll ========== */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ========== Animated stat counters ========== */
  function initStats() {
    var els = document.querySelectorAll('.stat-big[data-count]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var target = parseFloat(el.dataset.count);
        var suffix = el.dataset.suffix || '';
        var isFloat = target % 1 !== 0;
        var dur = 1400;
        var start = performance.now();
        (function tick(now) {
          var p = Math.min(1, (now - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = target * eased;
          el.textContent = (isFloat ? val.toFixed(1) : Math.round(val)) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        })(start);
        io.unobserve(el);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ========== One-tap reorder (account page) ========== */
  function initReorder() {
    var btns = document.querySelectorAll('[data-reorder]');
    if (!btns.length) return;
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.order-card');
        if (!card) return;
        var items = Array.prototype.slice.call(card.querySelectorAll('[data-reorder-item]'));
        if (!items.length) return;
        btn.disabled = true;
        var original = btn.textContent;
        btn.textContent = 'Rebuilding your order\u2026';

        var failures = 0;
        // add sequentially so cart order matches the original order
        var chain = Promise.resolve();
        items.forEach(function (el) {
          chain = chain.then(function () {
            var props = {};
            try { props = JSON.parse(el.getAttribute('data-props') || '{}'); } catch (e) {}
            props['Reordered from'] = btn.getAttribute('data-reorder') || 'previous order';
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                id: parseInt(el.getAttribute('data-variant'), 10),
                quantity: parseInt(el.getAttribute('data-qty'), 10) || 1,
                properties: props
              })
            }).then(function (r) { if (!r.ok) failures++; })
              .catch(function () { failures++; });
          });
        });
        chain.then(function () {
          if (failures === items.length) {
            btn.disabled = false;
            btn.textContent = 'Couldn\u2019t reorder \u2014 product may be unavailable';
            setTimeout(function () { btn.textContent = original; }, 4000);
          } else {
            btn.textContent = failures ? 'Added (some items unavailable) \u2192' : 'Added! Off to the cart \u2192';
            window.location.href = '/cart';
          }
        });
      });
    });
  }

  /* ========== Product showcase: lazy video + portfolio lightbox ========== */
  function initShowcase() {
    // click-to-load YouTube/Vimeo embed
    document.querySelectorAll('[data-video-embed]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-video-embed');
        if (!src) return;
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        btn.parentNode.replaceChild(iframe, btn);
      }, { once: true });
    });

    // lightbox for portfolio items
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-lightbox-src]'));
    if (!items.length) return;
    var overlay = document.createElement('div');
    overlay.className = 'lb-overlay';
    overlay.innerHTML =
      '<button type="button" class="lb-close" aria-label="Close">\u2715</button>' +
      '<button type="button" class="lb-nav lb-prev" aria-label="Previous">\u2190</button>' +
      '<img class="lb-img" alt="">' +
      '<div class="lb-caption"></div>' +
      '<button type="button" class="lb-nav lb-next" aria-label="Next">\u2192</button>';
    document.body.appendChild(overlay);
    var lbImg = overlay.querySelector('.lb-img');
    var lbCap = overlay.querySelector('.lb-caption');
    var current = 0;

    function show(i) {
      current = (i + items.length) % items.length;
      lbImg.src = items[current].getAttribute('data-lightbox-src');
      lbCap.textContent = items[current].getAttribute('data-lightbox-caption') || '';
    }
    function open(i) { show(i); overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function close() { overlay.classList.remove('open'); document.body.style.overflow = ''; }

    items.forEach(function (el, i) {
      el.addEventListener('click', function () { open(i); });
    });
    overlay.querySelector('.lb-close').addEventListener('click', close);
    overlay.querySelector('.lb-prev').addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
    overlay.querySelector('.lb-next').addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });
  }

  function init() {
    initTimers();
    initQuote();
    initConfigurator();
    initReorder();
    initShowcase();
    initReveal();
    initStats();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when Shopify theme editor reloads a section
  document.addEventListener('shopify:section:load', init);
})();
